import { Component } from '@angular/core';

@Component({
    selector: 'app-connect-with-expert',
    templateUrl: '/ng-app/src/app/components/home/connect-with-expert/connect-with-expert.component.html',
    styleUrls: ['../../../../../../ng-app/src/app/components/home/connect-with-expert/connect-with-expert.component.css'],
})
export class ConnectWithExpertComponent { }
